export type MercadoPagoPlanRow = {
  id: string;
  label: string;
  months: number;
  priceBrl: number;
  active: boolean;
  iptvPackageId?: number | null;
};

export function normalizeMercadoPagoPlan(
  p: Record<string, unknown>
): MercadoPagoPlanRow {
  const rawId = p.iptvPackageId ?? p.package_id;
  let iptvPackageId: number | null = null;
  if (rawId != null && rawId !== '') {
    const n = Number(rawId);
    if (Number.isFinite(n) && n > 0) iptvPackageId = n;
  }
  return {
    id: String(p.id ?? ''),
    label: String(p.label ?? ''),
    months: Math.min(60, Math.max(1, Number(p.months) || 1)),
    priceBrl: Number(p.priceBrl) || 0,
    active: p.active !== false,
    iptvPackageId
  };
}
